import './spacer.css';

export default function decorate(block: HTMLElement) {
	const height = [...block.classList]
		.find((c) => c.startsWith('height-'))
		?.split('-')[1];
	if (height) block.style.height = height;
	block.innerHTML = '';
}
